import {
  FieldArrayPath,
  FieldValues,
  UseFieldArrayProps,
  useFieldArray,
} from 'react-hook-form';

// type UseFieldsArrayOfParameters = Parameters<typeof useFieldArray>;

/**
 * Versione con tipizzazione migliorata di useFieldArray
 */
export const useFieldArrayOf = <
  T,
  TFieldValues extends FieldValues = { [key: string]: T[] },
>(
  props: UseFieldArrayProps<TFieldValues, FieldArrayPath<TFieldValues>>,
) => useFieldArray(props);
